/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import StaffMemberRouteLinkItem from './StaffMemberRouteLinkItem';
import LanguageCitizenshipIcon from 'icons/LanguageCitizenshipIcon';

const messages = defineMessages({
  title: {id: 'navigation.language-citizenship'},
});

const LanguageCitizenshipItem = () => (
  <StaffMemberRouteLinkItem
    iconBefore={LanguageCitizenshipIcon}
    route="midas/staff-member/language-citizenship"
    title={messages.title}
  />
);

export default LanguageCitizenshipItem;
